import React from 'react';
import PropTypes from 'prop-types';

import HtmlElement from '../HtmlElement';

export const HeadingLevels = [1, 2, 3, 4, 5, 6];
export const HeadingDefaultLevel = 3;

const defaultProps = {
  level: HeadingDefaultLevel,
  className: '',
};

const propTypes = {
  level: PropTypes.oneOf(HeadingLevels),
  className: PropTypes.string,
  children: PropTypes.string.isRequired,
};

const Heading = ({
  level,
  className,
  children,
}) => (
  <HtmlElement
    tagName={`h${level}`}
    className={className}
  >
    {children}
  </HtmlElement>
);

Heading.defaultProps = defaultProps;
Heading.propTypes = propTypes;

export default Heading;
